import React from "react";
import Heading from "./Heading";

const Address = () => {
  return (
    <div className="">
      <Heading>Address:</Heading>
      <p>
        St. Francis Institute of Technology,
        <br />
        Mount Poinsur, S.V.P. Road,
        <br />
        Borivali (W), Mumbai - 400103
      </p>
    </div>
  );
};

export default Address;
